import $ from 'jquery';
import '../components/index';
import './components/main.scss';
// eslint-disable-next-line no-console
import './website';



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/